import React from "react";
import { scaleRotate as Menu } from "react-burger-menu";
import { push as Menu1 } from "react-burger-menu";
import { useMenu } from "../context/MenuContext";
import useTab from "../hooks/useTab";
import useMobile from "../hooks/useMobile";
// import { Link } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";
import { scroller } from "react-scroll";
import { Link } from "react-router-dom";

const SidebarMenu = () => {
  const { menuOpen, setMenuOpen, handleStateChange } = useMenu();
  const { setLoading } = useLoader();
  const tab = useTab();
  const mobile = useMobile();
  const linkClicker = (path: string) => {
    const currentPath = window.location.pathname;
    const pathLocation =
      path === "/" ? currentPath === "/" : currentPath.includes(path);
    if (!pathLocation) {
      setLoading(true);
      window.scrollTo(0, 0);
      setMenuOpen(false);
    } else {
      setMenuOpen(false);
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
  };
  return (
    <>
      {tab || mobile ? (
        <Menu1
          isOpen={menuOpen}
          onStateChange={handleStateChange}
          pageWrapId={"page-wrap"}
          outerContainerId={"outer-container"}
          customBurgerIcon={false}
          customCrossIcon={false}
          styles={{
            bmBurgerButton: {
              display: "none",
            },
            bmCrossButton: {
              height: "24px",
              width: "24px",
            },
            bmMenuWrap: {
              position: "fixed",
              height: "100%",
              width: "300px",
            },
            bmMenu: {
              overflow: "hidden",
              background: "white",
              padding: "115px 50px 50px 50px",
              fontSize: "0.15em",
            },
            bmItemList: {
              color: "#b8b7ad",
              padding: "0.8em",
            },
            bmItem: {
              display: "block",
              fontSize: "20px",
              fontWeight: "400",
              textDecoration: "none",
            },
            bmOverlay: {
              background: "unset",
            },
          }}
        >
          <Link
            id="home"
            className="menu-item"
            to="/"
            onClick={() => linkClicker("")}
          >
            Home
          </Link>
          <Link
            id="our-rooms"
            className="menu-item"
            to="/our-rooms"
            onClick={() => linkClicker("our-rooms")}
          >
            Our Rooms
          </Link>
          <Link
            id="aboutus"
            className="menu-item"
            to="/aboutus"
            onClick={() => linkClicker("aboutus")}
          >
            About Us
          </Link>
          <Link
            id="contact"
            className="menu-item"
            to="/contact"
            onClick={() => linkClicker("contact")}
          >
            Contact
          </Link>
          {/* <Link
            id="about"
            className="menu-item disabled-link"
            to="/"
            onClick={(e) => e.preventDefault()}
          >
            Testimonials
          </Link> */}
          <Link
            id="contact"
            className="menu-item"
            to="/gallery"
            onClick={() => linkClicker("gallery")}
          >
            Gallery
          </Link>
          <Link
            id="faqs"
            className="menu-item"
            to="/faqs"
            onClick={() => linkClicker("faqs")}
          >
            FAQs
          </Link>
          <Link
            id="termscondition"
            className="menu-item"
            to="/terms-and-condition"
            onClick={() => linkClicker("terms-and-condition")}
          >
            Terms and Conditions
          </Link>
        </Menu1>
      ) : (
        <Menu
          isOpen={menuOpen}
          onStateChange={handleStateChange}
          pageWrapId={"page-wrap"}
          outerContainerId={"outer-container"}
          customBurgerIcon={false}
          customCrossIcon={false}
          styles={{
            bmBurgerButton: {
              display: "none",
            },
            bmCrossButton: {
              height: "24px",
              width: "24px",
            },
            bmMenuWrap: {
              position: "fixed",
              height: "100%",
              width: "400px",
            },
            bmMenu: {
              overflow: "hidden",
              background: "white",
              padding: "115px 90px 90px 90px",
              fontSize: "0.15em",
            },
            bmItemList: {
              color: "#b8b7ad",
              padding: "0.8em",
            },
            bmItem: {
              display: "block",
              fontSize: "20px",
              fontWeight: "400",
              textDecoration: "none",
            },
            bmOverlay: {
              background: "unset",
            },
          }}
        >
          <Link
            id="home"
            className="menu-item"
            to="/"
            onClick={() => linkClicker("/")}
          >
            Home
          </Link>
          <Link
            id="our-rooms"
            className="menu-item"
            to="/our-rooms"
            onClick={() => linkClicker("our-rooms")}
          >
            Our Rooms
          </Link>
          <Link
            id="aboutus"
            className="menu-item"
            to="/aboutus"
            onClick={() => linkClicker("aboutus")}
          >
            About Us
          </Link>
          <Link
            id="contact"
            className="menu-item"
            to="/contact"
            onClick={() => linkClicker("contact")}
          >
            Contact
          </Link>
          {/* <Link
            id="about"
            className="menu-item disabled-link"
            to="/"
            onClick={(e) => e.preventDefault()}
          >
            Testimonials
          </Link> */}
          <Link
            id="contact"
            className="menu-item"
            to="/gallery"
            onClick={() => linkClicker("gallery")}
          >
            Gallery
          </Link>
          <Link
            id="faqs"
            className="menu-item"
            to="/faqs"
            onClick={() => linkClicker("faqs")}
          >
            FAQs
          </Link>
          <Link
            id="termscondition"
            className="menu-item"
            to="/terms-and-condition"
            onClick={() => linkClicker("terms-and-condition")}
          >
            Terms and Conditions
          </Link>
        </Menu>
      )}
    </>
  );
};

export default SidebarMenu;
